{
  "$schema": "http://json-schema.org/draft-07/schema",
  "type": "object",
  "title": "Option Grant",
  "description": "Issue an option grant to an employee or contractor",
  "properties": {
    "authorized_signatory": {
      "$ref": "#/definitions/authorized_signatory"
    },
    "option_grant": { "$ref": "#/definitions/option_grant" },
    "company": { "$ref": "#/definitions/company" }
  },
  "additionalProperties": false
}
